import { appInsights } from "./app-insights-config";

// eslint-disable-next-line import/prefer-default-export
export const trackCustomEvent = (eventName: string, properties = {}) => appInsights.trackEvent({ name: eventName }, properties);

// export const trackCustomMetric = (eventName: string, properties = {}) =>
//   appInsights.trackMetric({ name: eventName }, properties);
